import { observer } from 'mobx-react-lite';
import ElementChildrenRenderer from './ElementChildrenRenderer';
import type { ElementChildrenRendererProps } from './types';

export type { ElementChildrenRendererProps };
export default observer(ElementChildrenRenderer);
